<template>
  <div class="foot_bour">
    <div class="box_info_foo">
      <div class="bo_iuty">
        <div class="icon_log" @click="$router.push('/')">
          <img src="../assets/footer/footer_icon.png" />
        </div>
        <div class="nav_tab onews">
          <div class="titles" @click="$router.push('/')">首页</div>
          <div class="titles" @click="$router.push('/news')">新闻中心</div>
          <div class="titles" @click="$router.push('/recruit')">招贤纳士</div>
          <div class="titles" @click="$router.push('/contactUs')">联系我们</div>
        </div>
        <div class="nav_tab twos">
          <div class="titles" @click="$router.push('/about')">关于升和</div>
          <div
            class="item_titles"
            @click="$router.push('/about/CompanyProfile')"
          >
            公司简介
          </div>
          <div
            class="item_titles"
            @click="$router.push('/about/EnterpriseHistory')"
          >
            企业历程
          </div>
          <div
            class="item_titles"
            @click="$router.push('/about/qualification')"
          >
            荣誉资质
          </div>
          <div
            class="item_titles"
            @click="$router.push('/about/CulturalConcept')"
          >
            文化理念
          </div>
        </div>
        <div class="nav_tab twos three">
          <div class="titles" @click="$router.push('/product')">产品中心</div>
          <div class="item_titles" @click="$router.push('/product/brand')">
            品牌产品
          </div>
          <div
            class="item_titles"
            @click="$router.push('/product/moreProduct')"
          >
            更多产品
          </div>
        </div>
        <div class="code_infos">
          <div class="code">
            <img src="../assets/footer/code.png" />
          </div>
          <div class="info">官方公众号</div>
        </div>
      </div>
    </div>
    <div class="botter">
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002000521"
        target="_blank"
      >
        <div class="txt_ou">川公网安备 51019002000521号</div>
      </a>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
        <div class="txt_ou">蜀ICP备2021018183号</div>
      </a>

      <div class="txt_ou">
        互联网药品信息服务名资格证书:川(备)-非经营性-2024-0036
      </div>

      <a href="https://www.trycheers.com/" target="_blank">
        <div class="txt_ou">技术支持：创企科技</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer",
};
</script>

<style scoped lang="less">
.foot_bour {
  cursor: pointer;
  .box_info_foo {
    height: 220px;
    display: flex;
    align-items: center;
    background: #00344e;
    .bo_iuty {
      width: 1084px;
      display: flex;
      margin: 0 auto;
      .icon_log {
        width: 103px;
        height: 169px;
        margin-right: 156px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .nav_tab {
        .titles {
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: #f0f8fe;
        }
        .item_titles {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #f0f8fe;
        }
      }
      .onews {
        margin-right: 172px;
        div {
          margin-bottom: 18px;
        }
      }
      .twos {
        margin-right: 171px;
        div {
          margin-bottom: 10px;
        }
      }
      .three {
        margin-right: 157px;
      }
      .code_infos {
        width: 106px;
        .code {
          width: 100%;
          height: 106px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          text-align: center;
          margin-top: 16px;
          font-size: 16px;
          font-family: SourceHanSansCN-Regular;
          color: #f0f8fe;
        }
      }
    }
  }
  .botter {
    height: 45px;
    background: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
    .txt_ou {
      font-size: 13px;
      font-family: MicrosoftYaHei;
      color: rgba(255, 255, 255, 0.8);
      margin-right: 41px;
    }
  }
}
@media (max-width: 1200px) {
  .foot_bour {
    cursor: pointer;
    .box_info_foo {
      height: 168px;
      display: flex;
      padding: 20px 0;
      align-items: center;
      background: #00344e;
      .bo_iuty {
        width: auto;
        padding: 0;
        height: 100%;
        display: flex;
        //justify-content: space-between;
        //margin: 0 auto;
        position: relative;
        .icon_log {
          width: 52px;
          height: 85px;
          margin-top: 35px;
          margin-right: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .nav_tab {
          .titles {
            font-size: 10px;
            font-family: MicrosoftYaHei;
            color: #f0f8fe;
          }
          .item_titles {
            font-size: 10px;
            font-family: MicrosoftYaHei;
            color: #f0f8fe;
          }
        }
        .onews {
          margin-right: 45px;
          div {
            margin-bottom: 11px;
          }
        }
        .twos {
          margin-right: 64px;
          div {
            margin-bottom: 10px;
          }
        }
        .three {
          margin-right: 13px;
        }
        .code_infos {
          width: 61px;
          position: absolute;
          bottom: 0;
          right: 0;
          //right:6px;
          .code {
            width: 100%;
            height: 61px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .info {
            text-align: center;
            margin-top: 8px;
            font-size: 8px;
            font-family: SourceHanSansCN-Regular;
            color: #f0f8fe;
          }
        }
      }
    }
    .botter {
      height: auto;
      padding: 15px 0;
      background: #333333;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      .txt_ou {
        font-size: 13px;
        margin-bottom: 0px;
        font-family: MicrosoftYaHei;
        color: rgba(255, 255, 255, 0.8);
        margin-right: 5px;
      }
    }
  }
}
</style>
